import React from 'react';
import './CSS/PokemonType.css'
import Comment from './Comment'
import Image from './Utilils/Image'
const PokemonType = () => {





    return (
        <>
            <div className="pokemonType">
           
            <Image />
                <div className="pokemonComments">
                    <Comment />
                </div>
                </div>
            
        </>
    )

}

export default PokemonType